import { Component, Input, ViewEncapsulation } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';
import { mailboxesRoute } from 'src/app/app-routing.module';
import { RegisterOptions } from 'src/app/common-components/register/models/register-options';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { MailboxPrivileges } from '../models/mailbox-privileges';
import { MailboxRegisterOptions } from '../models/mailbox-register-options';
import { MailboxRegisterListItem } from '../models/mailbox-register-results.model';
import { selectQuickFilters } from '../state/mailbox-register.reducer';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-mailbox-register-view',
    styleUrls: ['./mailbox-register-view.component.scss'],
    templateUrl: './mailbox-register-view.component.html',
    standalone: false
})
export class MailboxRegisterViewComponent extends EntityRegisterView<
   MailboxRegisterListItem,
   MailboxRegisterOptions,
   OrderingOption
> {
   protected selectQuickFilters(): (state: object) => RegisterOptions | null {
      return selectQuickFilters;
   }
   @Input() mailboxPrivileges: MailboxPrivileges;

   @Input() accountId: number | null;

   getRouterLink(id: number) {
      return `/${mailboxesRoute}/${id}`;
   }
}
